import { AnimatePresence } from 'framer-motion'

import { useManagementSearchSimApns } from '@apps-common/apis/management/sim-apn'
import { SimApnCardSkeleton, SimApnListCard } from '@apps-common/apps/portal/pages/management/components/sim-apn'
import { NoResultsCard, PullRefresh } from '@apps-common/components/common'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'

interface IProps {
  searchVal: string
}

export const SimApnInfiniteView: React.FC<IProps> = ({ searchVal }) => {
  const { isLoading, isError, data, isRefetching, refetch } = useManagementSearchSimApns({
    search: searchVal
  })

  const loading = isLoading || isRefetching || isError || !data

  return (
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[60px]'>
        <PullRefresh loading={isRefetching} callback={() => refetch()} />
        <AnimatePresence>
          <div className='flex flex-col gap-4'>
            {loading && Array.from(Array(10).keys()).map((n, i) => <SimApnCardSkeleton key={`sim-apn-card-skeleton-${i}`} />)}
            {!loading && data?.map((a) => <SimApnListCard key={`sim-apn-list-${a.id}`} apn={a} />)}
            {!loading && data && data.length === 0 && <NoResultsCard>No APN results.</NoResultsCard>}
          </div>
        </AnimatePresence>
      </LayoutPadding>
    </LayoutContainer>
  )
}
